import * as Sentry from '@sentry/react';
import {ErrorEvent} from '@sentry/react';

const SentryErrorLevel = 'error';

const filterSentryLogging = (event: ErrorEvent) => {
  if (event.level !== SentryErrorLevel) return null;
  else return event;
};

const safeCaptureException = (error: unknown, context?: string) => {
  try {
    if (error instanceof Error) {
      Sentry.captureException(error);
    } else if (typeof error === 'string') {
      Sentry.captureException(new Error(error));
    } else if (error && typeof error === 'object') {
      const message = (error as {message?: string}).message || JSON.stringify(error);
      Sentry.captureException(new Error(message));
    } else {
      const message = context ? `${context}: ${String(error)}` : String(error);
      Sentry.captureException(new Error(message));
    }
  } catch (sentryError) {
    console.error('Failed to capture exception to Sentry:', sentryError);
    console.error('Original error:', error);
  }
};

export {filterSentryLogging, safeCaptureException};
